import axiosClient from '@/shared/axios';
import { USER } from '@/shared/constants/endpoints';
import { clearSession } from '@/shared/store/session';

export const LoginUser = (params) => axiosClient.post(USER.LOGIN, params);

export const GetUserData = (id) => {
  return axiosClient.get(USER.PROFILE.replace(':id', id));
};

export const ResetLink = (email) =>
  axiosClient.post(USER.RESET_PASSWORD, email);

export const ChangePassword = (params) =>
  axiosClient.post(USER.CHANGE_PASSWORD, params);

export const RefreshToken = (refreshToken) => {
  return axiosClient.post(
    USER.REFRESH_TOKEN,
    {
      refresh_token: refreshToken,
    },
    {
      skipAuthRefresh: true,
    }
  );
};

export const LogoutUser = () => {
  clearSession();
  localStorage.removeItem('token');
  axiosClient.defaults.headers.Authorization = null;
};
